import { SettingsAppearancePage } from "@/components/settings/appearance/page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/settings/appearance")({
  component: SettingsAppearancePage,
});
